"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var localStyles = require("./VoipCart.scss");
var ui_components_1 = require("@idp/ui-components");
var utils_1 = require("@idp/ui-components/utils");
var PriceContainerProps_1 = require("@idp/ui-components/components/cards/PriceContainer/PriceContainerProps");
var Api_1 = require("../../../api/Api");
var ReportingService_1 = require("../../../api/ReportingService");
var StateProvider_1 = require("../../../api/StateProvider");
var Utils = require("../../../utils/UtilityFunctions");
var CartItemPromo_1 = require("../../atoms/CartItemPromo");
var cms_integration_1 = require("@idp/cms-integration");
var Cart_cms_1 = require("../../../cms/Cart.cms");
var VoipCart = /** @class */ (function (_super) {
    __extends(VoipCart, _super);
    function VoipCart(props) {
        var _this = _super.call(this, props) || this;
        _this.api = new Api_1.default();
        _this.reportingService = new ReportingService_1.default();
        _this.stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        _this.setPriceContainer = _this.setPriceContainer.bind(_this);
        return _this;
    }
    VoipCart.prototype.render = function () {
        var payload = Utils.getCartResp();
        var numberOfKeys;
        var lineItem;
        var voipPackage = [];
        var addOns = [];
        var voipIntegratedDevice = [];
        var cmsData = cms_integration_1.CMS.get(new Cart_cms_1.CartCms(), 'cartcheckout').content;
        var voipCartAmount = this.getVoipCartAmount(payload);
        if (cmsData.broadbandCart && cmsData.broadbandCart.cartSummary) {
            this.cmsContent = cmsData.broadbandCart.cartSummary;
        }
        if (payload) {
            numberOfKeys = Object.keys(payload.voipCart.losgs);
            this.voipCartLosgs = Object.values(payload.voipCart.losgs);
            this.voipCartLosgs.forEach(function (e, i) {
                if (e.primaryIndicator === true) {
                    Object.keys(e.lineItems).forEach(function (key) {
                        lineItem = e.lineItems[key];
                        switch (lineItem.itemType) {
                            case 'voip':
                                voipPackage.push(lineItem);
                                break;
                            case 'voipIntegratedAccessDevice':
                                voipIntegratedDevice.push(lineItem);
                                break;
                            case 'directoryListing':
                                addOns.push(lineItem);
                                break;
                        }
                    });
                }
            });
        }
        return (React.createElement("div", { className: localStyles.voipcart },
            React.createElement("div", { className: localStyles.solidLineLightGray }),
            React.createElement("div", null,
                React.createElement("span", { className: localStyles.strongCart }, "Voice"),
                React.createElement("div", null, this.getPlanLineItem(voipPackage, numberOfKeys, voipCartAmount)),
                this.displayAddOns(addOns),
                this.displayInstallation(voipIntegratedDevice))));
    };
    VoipCart.prototype.getVoipCartAmount = function (payload) {
        var _a;
        var voipAmount = 0;
        var voipCartLosgs = payload && Object.values((_a = payload === null || payload === void 0 ? void 0 : payload.voipCart) === null || _a === void 0 ? void 0 : _a.losgs);
        if (voipCartLosgs && voipCartLosgs.length > 0) {
            voipCartLosgs.forEach(function (e) {
                if (e === null || e === void 0 ? void 0 : e.lineItems) {
                    Object.keys(e.lineItems).forEach(function (key) {
                        var _a, _b, _c, _d;
                        if (((_b = (_a = e.lineItems) === null || _a === void 0 ? void 0 : _a[key]) === null || _b === void 0 ? void 0 : _b.itemType) === 'voip') {
                            voipAmount += +((_d = (_c = e.lineItems) === null || _c === void 0 ? void 0 : _c[key]) === null || _d === void 0 ? void 0 : _d.price.amount);
                        }
                    });
                }
            });
        }
        return voipAmount;
    };
    VoipCart.prototype.getPlanLineItem = function (pLineItem, numberOfKeys, voipCartAmount) {
        var _this = this;
        var displayLines;
        return pLineItem.map(function (element) {
            if (numberOfKeys.length < 2) {
                displayLines = numberOfKeys.length + " line";
            }
            else {
                displayLines = numberOfKeys.length + " lines";
            }
            return (React.createElement("div", { key: "lineItem_" + element.id, id: "lineItem_" + element.id },
                React.createElement("div", null,
                    React.createElement("div", { className: localStyles.lineItemPlanContainer },
                        React.createElement("div", { className: localStyles.lineItemName },
                            React.createElement("div", { id: utils_1.default('voip', 'Label', 'LineItem'), className: "" },
                                React.createElement(ui_components_1.RichText, { testId: utils_1.default('voip', 'Label', 'LineItem'), data: { text: element.displayName } })),
                            React.createElement("div", null,
                                React.createElement(ui_components_1.RichText, { testId: utils_1.default('voip', 'Label', 'TolatLosgCount'), data: { text: displayLines } }))),
                        React.createElement("div", { className: localStyles.lineItemPrice }, element.price &&
                            React.createElement("div", null,
                                React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('voip', 'PriceContainer', 'LineItem'), data: {
                                        billingNote: (element.price.priceType === 'RC') ? '/mo.' : '',
                                        price: voipCartAmount,
                                    }, options: {
                                        className: localStyles.lineItem,
                                        decimalPoints: 2,
                                        type: PriceContainerProps_1.PricingType.XSMALL,
                                    } }))))),
                _this.getPromotion(element)));
        });
    };
    VoipCart.prototype.setPriceContainer = function (priceData) {
        return (React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('Voip', 'PriceContainer', 'LineItemAddons'), data: {
                billingNote: (priceData.priceType === 'RC') ? '/mo' : '',
                price: (priceData.baseAmount) ? priceData.baseAmount : 0,
            }, options: {
                className: localStyles.lineItem,
                decimalPoints: 2,
                type: PriceContainerProps_1.PricingType.XSMALL,
            } }));
    };
    VoipCart.prototype.displayAddOns = function (addOns) {
        if (addOns.length > 0 &&
            (typeof addOns[0].price.baseAmount === 'string')) {
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: [localStyles.strongCart, localStyles.paddingtop15].join(' ') }, this.cmsContent.addonTitle || 'Add-ons'),
                this.getLineItem(addOns, true, true)));
        }
        else {
            return (React.createElement(React.Fragment, null));
        }
    };
    VoipCart.prototype.displayInstallation = function (installationItem) {
        if (installationItem.length > 0 &&
            ((installationItem[0].price !== undefined) && typeof installationItem[0].price.baseAmount === 'string')) {
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: [localStyles.strongCart, localStyles.paddingtop15].join(' ') }, this.cmsContent.oneTimeChargeTitle || 'One-time charge:'),
                this.getLineItem(installationItem, true, true)));
        }
        else {
            return (React.createElement(React.Fragment, null));
        }
    };
    VoipCart.prototype.getLineItem = function (pLineItem, displayPriceIfZero, includedIfPriceZero, overwriteDisplayName) {
        var _this = this;
        return pLineItem.map(function (element, index) {
            return (React.createElement("div", { key: "lineItem_" + element.id, id: "lineItem_" + element.id },
                React.createElement("div", null,
                    React.createElement("div", { className: localStyles.lineItemContainer },
                        React.createElement("div", { className: localStyles.lineItemName },
                            React.createElement("div", { id: "itemName_" + element.id, className: "" },
                                React.createElement(ui_components_1.RichText, { testId: utils_1.default('voip', 'Label', 'LineItemAddons'), data: { text: element.displayName } }))),
                        React.createElement("div", { className: localStyles.lineItemPrice },
                            React.createElement("div", { id: "lineItemPrimaryPrice_" + element.id }, _this.setPriceContainer(element.price))))),
                _this.getPromotion(element)));
        });
    };
    VoipCart.prototype.getPromotion = function (pLineItem) {
        var payload = Utils.getCartResp();
        if (pLineItem.promotionReferences) {
            var promotionNameArry_1 = new Array();
            var promoName_1 = '';
            var isHsiaBasePackage_1 = false;
            return pLineItem.promotionReferences.map(function (element, index) {
                if (payload.voipCart.promotions) {
                    return payload.voipCart.promotions.map(function (promoElem) {
                        var pc = promoElem.promotionCycle;
                        var amount = 0;
                        if (promoElem.promoDiscountAmount) {
                            amount = parseFloat(promoElem.promoDiscountAmount);
                        }
                        else {
                            amount = promoElem.amount;
                        }
                        if (element === promoElem.id) {
                            if (pLineItem && pLineItem.itemType
                                && promoElem && promoElem.promotionName) {
                                isHsiaBasePackage_1 = true;
                                if (amount > 0) {
                                    promotionNameArry_1.push(promoElem.promotionName);
                                }
                                if (pLineItem.promotionReferences.length === (index + 1)) {
                                    promoName_1 = promotionNameArry_1.join(' + extra ');
                                    isHsiaBasePackage_1 = false;
                                }
                            }
                            else {
                                promoName_1 = amount > 0 ? promoElem.promotionName : '';
                            }
                            return (React.createElement(React.Fragment, null,
                                !isHsiaBasePackage_1 && promoName_1 && pLineItem.itemType !== 'voip' &&
                                    React.createElement("div", { key: "promo_" + promoElem.id, id: "promo_" + promoElem.id },
                                        React.createElement(CartItemPromo_1.default, { data: {
                                                isPriceNegative: true, promoPrice: amount,
                                                promoText: promoName_1, promotionCycle: pc,
                                                showPrice: (pLineItem.itemType !== 'voip'),
                                            }, options: { testId: utils_1.default('Voip', 'LineItem') } })),
                                " ",
                                isHsiaBasePackage_1 &&
                                    React.createElement(React.Fragment, null, " ")));
                        }
                        else {
                            return '';
                        }
                    });
                }
                else {
                    return '';
                }
            });
        }
        else {
            return '';
        }
    };
    return VoipCart;
}(React.Component));
exports.default = VoipCart;
//# sourceMappingURL=VoipCart.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/VoipCart/VoipCart.js
// module id = 2318
// module chunks = 8